/*export function getBoundingBoxCenter(rooms: any[]) {
  // Initialize min and max values for x and y
  let minX = -Infinity;
  let minY = -Infinity;
  let maxX = Infinity;
  let maxY = Infinity;

  // Loop through all coordinates to find the bounding box
  for (const room of rooms) {
    const [x, y] = room.coordinates;
    minX = Math.min(minX, x);
    minY = Math.min(minY, y);
    maxX = Math.max(maxX, x);
    maxY = Math.max(maxY, y);
  }

  // Calculate the center of the bounding box
  const centerX = (minX + maxX) / 2;
  const centerY = (minY + maxY) / 2;
  let closest: any | null = null;
  for (const room of rooms) {
    const [x, y] = room.coordinates;
    if (!closest || (
      Math.abs(x - centerX) < Math.abs(closest.coordinates[0] - centerX)) &&
      Math.abs(y - centerY) < Math.abs(closest.coordinates[1] - centerY)
    ) {
      closest = room;
    }
  }

  return { x: closest.coordinates[0], y: closest.coordinates[1] };
}*/

export function getBoundingBoxCenter2(rooms: any[]) {
  // Initialize min and max values for x and y
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;

  // Loop through all coordinates to find the bounding box
  for (const room of rooms) {
    const [x, y] = room.coordinates;
    minX = Math.min(minX, x);
    minY = Math.min(minY, y);
    maxX = Math.max(maxX, x);
    maxY = Math.max(maxY, y);
  }

  // Calculate the center of the bounding box
  const centerX = (minX + maxX) / 2;
  const centerY = (minY + maxY) / 2;
  
  let closest: any | null = null;
  let closestDistance = Infinity;
  for (const room of rooms) {
    const [x, y] = room.coordinates;
    const dist = Math.sqrt((centerX - x)*(centerX - x) + (centerY - y)*(centerY - y));
    if (dist < closestDistance) {
      closest = room;
      closestDistance = dist;
    }    
  }

  return closest;
}

export function getBoundingBoxCenter3(canvas: HTMLCanvasElement, rooms: any[]) {
  // Initialize min and max values for x and y
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;

  // Loop through all coordinates to find the bounding box
  for (const room of rooms) {
    const [x, y] = room.coordinates;
    minX = Math.min(minX, x);
    minY = Math.min(minY, y);
    maxX = Math.max(maxX, x);
    maxY = Math.max(maxY, y);
  }

  // Calculate the center of the bounding box
  const centerX = (minX + maxX) / 2;
  const centerY = (minY + maxY) / 2;

  const scaleX = canvas.width / (maxX - minX);

  return { x: centerX, y: centerY, scale: scaleX };
}